import "./index.css";

import * as Sentry from "@sentry/react";

import App from "./App";
import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import { db } from "../src/indexDB/model";
import serviceWorkerRegistration from "./serviceWorkerRegistration";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development'
});

// const container = document.getElementById("app");
// const root = createRoot(container);
async function initializeApp() {
  try {
    await db.datapoints.toCollection().modify({ syncing: false });
    console.log("Removed locks of all datapoints");
  } catch (error) {
    console.error("Error during initialization:", error);
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<App />);
}

initializeApp();
